import {Vue} from '~/addiesaas'
import ReEmailInput from './re-email-input'
Vue.component(ReEmailInput.name, ReEmailInput)

export default {
  ReEmailInput,
}
